// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/radio-station-licence.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/radio-station-licence/radio-station-licence.js';

mount([g0]);
